import { ContractInterface } from '@vendasta/billing';
import { Currency, currencyFromApi } from '../pricing';
import { Dimension } from './dimension';

export interface Contract {
  merchantId: string;
  netD: number;
  created?: Date;
  subscriptionId: string;
  dimension: Dimension;
  currency: Currency;
  signed?: Date;
  end?: Date;
  activated?: Date;
  modified?: Date;
  verified?: Date;
  status: string;
  creditLimit: number;
  pricingPlanId: string;
}

export function contractFromApi(cApi: ContractInterface): Contract {
  return {
    merchantId: cApi.merchantId || '',
    netD: cApi.netD || 0,
    created: cApi.created || undefined,
    subscriptionId: cApi.subscriptionId || '',
    dimension: new Dimension(cApi.dimension || ''),
    currency: currencyFromApi(cApi.currency),
    signed: cApi.signed || undefined,
    end: cApi.end || undefined,
    activated: cApi.activated || undefined,
    modified: cApi.modified || undefined,
    verified: cApi.verified || undefined,
    status: cApi.status || '',
    creditLimit: cApi.creditLimit || 0,
    pricingPlanId: cApi.pricingPlanId || '',
  };
}
